module.exports = __webpack_public_path__ + "img/carnation.be5030ca.webp";